<template>
  <div>
    <a-breadcrumb style="margin: 16px 0">
      <a-breadcrumb-item
        ><router-link to="/teacher/workGroup"
          >作业批改</router-link
        ></a-breadcrumb-item
      >
      <a-breadcrumb-item>查看作业</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="header">
      <a-row class="unit-info" v-if="unitInfo">
        <a-col :span="6">
          <img :src="unitInfo.unitCover_url" alt="" />
        </a-col>
        <a-col :span="18">
          <h2>课程单元：{{ unitInfo.unitName }}</h2>
          <p>班级：{{ unitInfo.departName }}</p>
          <p>作业类型：{{ unitInfo.codeType_dictText }}</p>
          <p>
            布置时间：{{ unitInfo.workOpenTime || unitInfo.workCaseOpenTime }}
          </p>
        </a-col>
      </a-row>
      <a-tabs default-active-key="1">
        <a-button slot="tabBarExtraContent" type="link" @click="getUnitInfo"
          ><a-icon type="reload" /> 刷新</a-button
        >
        <a-tab-pane key="1" :tab="'已提交 ' + unitInfo.submitCount">
          <TeacherWorkList isInner />
        </a-tab-pane>
        <a-tab-pane
          key="2"
          :tab="'未提交 ' + ((unitInfo.assignWorkCount * unitInfo.studentCount) - unitInfo.submitCount)"
        >
          <TeacherUnsubmitedStudent isInner />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import TeacherWorkList from "./TeacherWorkList";
import TeacherUnsubmitedStudent from "./TeacherUnsubmitedStudent"

export default {
  name: "TeacherWorkListUnitWrap",
  components: {
    TeacherWorkList,
    TeacherUnsubmitedStudent
  },
  props: {
    isInner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unitInfo: {},
    };
  },
  created() {
    this.getUnitInfo();
  },
  methods: {
    getUnitInfo() {
      if (this.$route.query.unitId && this.$route.query.departId) {
        getAction("/teaching/teachingWork/teacherCourseWorkGroupByCourse", {
          unitId: this.$route.query.unitId,
          departId: this.$route.query.departId,
        }).then((res) => {
          if (res.success && res.result.total > 0) {
            this.unitInfo = res.result.records[0];
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  .unit-info {
    img {
      width: 90%;
      max-height: 280px;
    }
  }
}
</style>